import axios from 'axios'
import { Message } from 'element-ui'


const logDebug = false

// create an axios instance
const service = axios.create({
  //测试服
  baseURL: 'https://test-mngame-cms-api.atomgameteam.com',
  //正式服
  // baseURL: 'https://mngame-cms-api.atomgameteam.com',
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // removeNullItem(config.data)
    // removeNullItem(config.params)
    logDebug && console.log('baseUrl:' + JSON.stringify(config.baseURL)) // for debug
    logDebug && console.log('rul:' + JSON.stringify(config.url)) // for debug
    logDebug && console.log('post 参数' + JSON.stringify(config.data)) // for debug
    logDebug && console.log('get 参数' + JSON.stringify(config.params)) // for debug
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    logDebug && console.log('response============', res) // for debugsss

    // if the custom code is not 20000, it is judged as an error.
    // console.log(res)
    if (res.code !== 20000 && res.code !== 0) {
      Message({
        message: res.msg || res.data.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res.msg || res.data.msg || 'Error')
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
